import { render } from "./preview.vue?vue&type=template&id=0979538b&scoped=true&lang=pug"
import script from "./preview.vue?vue&type=script&setup=true&lang=js"
export * from "./preview.vue?vue&type=script&setup=true&lang=js"

import "./preview.vue?vue&type=style&index=0&id=0979538b&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/prod__jobjam-homebrew/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0979538b"]])

export default __exports__